import { Table, TableColumnsType, Typography } from 'antd';
import { TableProps } from 'antd/es/table';
import { StyledTableHeaderCell, StyledTableWrapper } from 'components/new-ui/base/table/styles';
import { AmendmentChange } from './utils';

type Props = Omit<TableProps<AmendmentChange>, 'dataSource'> & {
    changes: AmendmentChange[];
};

const AmendmentSummaryTable = ({ changes, ...rest }: Props) => {
    const columns: TableColumnsType<AmendmentChange> = [
        {
            title: 'Field',
            key: 'fieldName',
            render: (_, record) => {
                return <Typography.Text>{record.label}</Typography.Text>;
            },
        },
        {
            title: 'Current Value',
            key: 'currentValue',
            render: (_, record) => {
                return <Typography.Text>{record.currentValue}</Typography.Text>;
            },
        },
        {
            title: 'Updated Value',
            key: 'newValue',
            render: (_, record) => {
                return <Typography.Text>{record.newValue}</Typography.Text>;
            },
        },
    ];

    return (
        <StyledTableWrapper className="no-last-row-border">
            <Table<AmendmentChange>
                dataSource={changes}
                columns={columns}
                components={{
                    header: {
                        cell: (props: any) => <StyledTableHeaderCell {...props} />,
                    },
                }}
                {...rest}
            />
        </StyledTableWrapper>
    );
};

export default AmendmentSummaryTable;
